/**
 * Krok 6: Kontakt — telefon, email, www, social, godziny.
 */
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Phone, Mail, Globe, Facebook, Instagram, Clock, CheckCircle2 } from 'lucide-react';

export default function Step6Contact({ data, updateData }) {
  return (
    <div className="space-y-8" data-testid="business-wizard-v2-step-contact">
      <header>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-9 h-9 rounded-lg bg-orange-100 flex items-center justify-center">
            <CheckCircle2 className="w-5 h-5 text-orange-500" />
          </div>
          <span className="text-xs uppercase tracking-wider font-semibold text-orange-600">Krok 6 z 7</span>
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Jak się z Tobą skontaktować?</h2>
        <p className="text-sm text-gray-500 mt-1">Im więcej kanałów, tym łatwiej klient kliknie „zadzwoń”.</p>
      </header>

      <section className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <Label className="text-xs text-gray-600 mb-1 flex items-center gap-1.5"><Phone className="w-3.5 h-3.5 text-orange-500" /> Telefon</Label>
          <Input
            value={data.phone || ''}
            onChange={(e) => updateData({ phone: e.target.value })}
            placeholder="+48 600 000 000"
            data-testid="bwv2-phone-input"
          />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-orange-500" /> Email</Label>
          <Input
            type="email"
            value={data.email || ''}
            onChange={(e) => updateData({ email: e.target.value })}
            placeholder="kontakt@twojafirma.pl"
            data-testid="bwv2-email-input"
          />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 flex items-center gap-1.5"><Globe className="w-3.5 h-3.5 text-orange-500" /> Strona WWW</Label>
          <Input
            value={data.website || ''}
            onChange={(e) => updateData({ website: e.target.value })}
            placeholder="https://twojafirma.pl"
            data-testid="bwv2-website-input"
          />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-orange-500" /> Godziny otwarcia</Label>
          <Input
            value={data.opening_hours || ''}
            onChange={(e) => updateData({ opening_hours: e.target.value })}
            placeholder="Pn-Pt 9:00–18:00, Sb 10:00–14:00"
            data-testid="bwv2-hours-input"
          />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 flex items-center gap-1.5"><Facebook className="w-3.5 h-3.5 text-blue-600" /> Facebook</Label>
          <Input
            value={data.social_facebook || ''}
            onChange={(e) => updateData({ social_facebook: e.target.value })}
            placeholder="https://facebook.com/twojafirma"
            data-testid="bwv2-fb-input"
          />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 flex items-center gap-1.5"><Instagram className="w-3.5 h-3.5 text-pink-600" /> Instagram</Label>
          <Input
            value={data.social_instagram || ''}
            onChange={(e) => updateData({ social_instagram: e.target.value })}
            placeholder="https://instagram.com/twojafirma"
            data-testid="bwv2-ig-input"
          />
        </div>
      </section>

      <section>
        <Label className="text-xs text-gray-600 mb-1 block">Dodatkowe informacje kontaktowe (opcjonalnie)</Label>
        <Textarea
          value={data.contact_note || ''}
          onChange={(e) => updateData({ contact_note: e.target.value })}
          placeholder="np. Wizyty tylko po umówieniu. Najszybszy kontakt przez WhatsApp."
          rows={3}
          data-testid="bwv2-contact-note-input"
        />
      </section>
    </div>
  );
}
